import getAxiosInstance from '../../../../helpers/get_axios_instance'
import lrsAdapter from '../../../../helpers/lrs_adapter'

export class TablaPedidoCamionesEnPlayaInsatisfechoService {
  static async getDataPedidosCamionesEnPlayaInsatisfecho () {
    const axios = getAxiosInstance()
    return axios.get(`/pedido_de_egreso_playa_insatisfecho?r=` +
    `{"orden": ["d:fecha_de_pedido"]}`).then(lrsAdapter, lrsAdapter)
      .then(result => result.data)
  }
}
